//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import divSpan from '@/components/DivSpan';
export default {
  name: "assess-report",
  components:{
    divSpan
  },
  data(){
    return{
      tabIndex:1,
      wrapperHeight:0,
      allLoaded:false,
      config:{
        title:'供应商绩效',
        url:'api/sup-ass-flow/page',
        workflowSearchBean:{},
        tabList:['查询供应商绩效','供应商绩效待办'],
        fixRules:{},
        inputCondition:{
          placeholder:'考核方案编号/名称/单号',
          searchCondition:'key',
          rules:[{field: "supAssPlan.code-supAssPlan.name-requestBase.title-requestBase.serialNo", option: "LIKE_ANYWHERE"}]
        },
      },
      configTodo:{
        title:'供应商绩效',
        url:'api/sup-ass-flow/page',
        workflowSearchBean:{},
        tabList:['查询供应商绩效','供应商绩效待办'],
        fixRules:{},
        inputCondition:{
          placeholder:'考核方案编号/名称/单号',
          searchCondition:'key',
          rules:[{field: "supAssPlan.code-supAssPlan.name-requestBase.title-requestBase.serialNo", option: "LIKE_ANYWHERE"}]
        },

      },
      list:[],
      show:true
    }
    },
  methods:{
    getTabIndex(e){
      this.tabIndex = e;
    },
    getList(e,met,bol){
      this.$nextTick(()=>{
        if(bol){
          this.list = this.list.concat(e);
        }else{
          this.list = e;
        }
        if(met === 'top'){
          this.$refs.loadmore.onTopLoaded();
        }
        if(met === 'bottom'){
          this.$refs.loadmore.onBottomLoaded();
        }
      })
    },
    goDetail(obj){
      let str = '/workflow/'+obj.requestId+'?component=SupAssFlowReadComponent&title=供应商绩效&orderNo=';
      if(obj.requestBase){
        str += ('No.' +obj.requestBase.serialNo);
      }
      this.$router.push(str);
    },

    init: function() {
      // 父控件要加上高度，否则会出现上拉不动的情况
      this.wrapperHeight = document.documentElement.clientHeight - this.$refs.wrapper.getBoundingClientRect().top - 10;
    },
    loadTop(){
      this.$refs.header.getlist(true);
    },
    loadBottom(){
      this.$refs.header.getMore();
    },
    getWorkFlow(){
      this.$get('api/biz-object-parameters/key/supAss').then(data=>{
        this.configTodo.workflowSearchBean = {
          workflowId: data.workflowType,
          searchType: '0',
          workflowClass: "supAssWorkflowImpl"
        };
        this.$refs.header.getlist();
      })
    },
  },
  mounted(){
    this.init();
    this.$refs.header.tabIndex=this.$route.query.tabIndex||1;
    this.tabIndex=this.$route.query.tabIndex||1;
    this.getWorkFlow();
  }
}



// WEBPACK FOOTER //
// ./src/page/supplier-assess/assess-report.vue